import makeRequest from './client';

export const getGuidanceDoc = () => makeRequest(`/guidancedocument`, `GET`);

export const getGuidanceDocById = (key: string) => makeRequest(`/guidancedocument/${key}`, `GET`);

export const updateGuidanceDocById = (id: number, payload: any) =>
  makeRequest(`/guidancedocument/${id}`, `POST`, payload);

export const getNotifications = (type: string) =>
  makeRequest(`/guidance/notification/${type}`, `GET`);

export const updateNotificationData = (id: number, payload: any) =>
  makeRequest(`/guidance/notification/${id}`, `POST`, payload);

export const getS3URL = (payload: any) => makeRequest(`/guidance/s3_url`, `POST`, payload);
